<app-temp-modal-cadastro #modalCadastro modalContentId="modal-atualizar-crt" (closed)="onClose()"
  textHeader="Atualizar Código de Regime Tributário" customClass="modal-lg">
  <form [formGroup]="cadastroForm" (ngSubmit)="submit()">
    <p>
      A SEFAZ recusou a nota porque o Código de Regime Tributário (CRT) está incorreto.<br>
      Corrija as informações abaixo e tente novamente.
    </p>

    <div class="row">
      <div class="col-sm-12 form-group">
        <label style="font-weight: bold">CRT</label>
        <ng-select placeholder="Selecione" [items]="crtOptions" bindLabel="name" bindValue="id" formControlName="crt"
          appendTo="#modal-atualizar-crt" [readonly]="loading">
        </ng-select>
        <ng-container *ngIf="cadastroForm.get('crt').value === 3">
          <div class="row mt-2">
            <div class="form-radio col-sm-12">
              Regime PIS/COFINS
              <div class="radio radio-inline">
                <label>
                  <input type="radio" formControlName="regimePIS_COFINS" value="P" />
                  <i style="top: 0;" class="helper"></i> <span>Lucro Presumido</span>
                </label>
              </div>
              <div class="radio radio-inline">
                <label>
                  <input type="radio" formControlName="regimePIS_COFINS" value="R" />
                  <i style="top: 0;" class="helper"></i> <span>Lucro Real</span>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
        <show-errors [control]="cadastroForm.controls.crt"></show-errors>
      </div>
    </div>

    <div class="form-button-row">
      <button class="btn btn-primary custom-form-button" type="submit" [disabled]="loading">
        <app-loading [loading]="loading" [texto]="'Salvar'" [textoLoading]="'Salvando'"
          [icone]="'icofont icofont-save'"></app-loading>
      </button>
      <button class="btn btn-danger custom-form-button" type="button" (click)="modalCadastro.hide()" [disabled]="loading">
        <i class="ti ti-close"></i> Cancelar
      </button>
    </div>
  </form>
</app-temp-modal-cadastro>
